import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { landingPageService, type TestimonialsSection } from "../services/landingPageService";

interface LandingTestimonialsState {
  data: TestimonialsSection | null;
  loading: boolean;
  error: string | null;
}

const initialState: LandingTestimonialsState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchLandingTestimonials = createAsyncThunk(
  "landingTestimonials/fetch",
  async (_, { rejectWithValue }) => {
    try {
      return await landingPageService.getTestimonials();
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch testimonials section"
      );
    }
  }
);

const landingTestimonialsSlice = createSlice({
  name: "landingTestimonials",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLandingTestimonials.fulfilled, (state, action: PayloadAction<TestimonialsSection>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLandingTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default landingTestimonialsSlice.reducer;